import { ArrowUpRight } from "lucide-react";

export default function FinalCTA() {
  return (
    <section
      data-testid="final-cta-section"
      className="relative py-16 md:py-24 bg-[#050505] overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="reveal relative rounded-[2rem] md:rounded-[2.5rem] border border-white/10 overflow-hidden bg-[#0A0F1C] p-10 md:p-20">
          {/* background flares */}
          <div className="absolute -top-32 left-1/4 h-96 w-96 rounded-full bg-[#007AFF]/30 blur-[140px]" />
          <div className="absolute -bottom-32 right-1/4 h-96 w-96 rounded-full bg-[#00F0FF]/15 blur-[140px]" />
          <div className="absolute inset-0 ring-grid opacity-30" />

          <div className="relative max-w-3xl">
            <div className="text-xs font-bold tracking-[0.22em] uppercase text-[#00F0FF]">
              / Let's go
            </div>
            <h2 className="mt-5 font-display font-black leading-[0.9] tracking-[-0.04em] text-[clamp(2.6rem,7vw,5.5rem)]">
              Ready to upgrade
              <br />
              your business?
            </h2>
            <p className="mt-7 text-lg md:text-xl text-slate-300/90 max-w-xl leading-relaxed">
              Book a 30-minute, zero-pitch consultation. We'll map the highest-leverage
              moves for your business — yours to keep, even if we never work together.
            </p>

            <div className="mt-10 flex flex-col sm:flex-row gap-4">
              <a
                href="#contact"
                data-testid="final-cta-primary"
                className="group inline-flex items-center gap-2 pl-7 pr-2 py-2 rounded-full bg-white text-black font-semibold hover:bg-[#00F0FF] transition-all duration-300"
              >
                Let's build together
                <span className="grid place-items-center h-10 w-10 rounded-full bg-black text-white">
                  <ArrowUpRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                </span>
              </a>
              <a
                href="mailto:info@brandwithabdo.co.uk"
                data-testid="final-cta-secondary"
                className="inline-flex items-center px-6 py-3 rounded-full border border-white/15 text-white/90 hover:bg-white/5 transition-colors"
              >
                info@brandwithabdo.co.uk
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
